import React from 'react';
import styles from './About.module.css';
import { personal, aboutFocus, aboutInterests } from '../data/portfolio';

export default function About() {
  return (
    <div className="stack fade-in" style={{ marginBottom: '64px' }}>
      <div className="stack-inner">
        <div className={styles.inner}>
          <div>
            <p className={styles.label}>Currently</p>
            <p className={styles.value}>{personal.university}<br />Expected May 2026</p>
            <p className={styles.label}>Location</p>
            <p className={styles.value}>{personal.location}</p>
            <p className={styles.label}>Contact</p>
            <p className={styles.value}>
              <a href={`mailto:${personal.email}`}>{personal.email}</a><br />{personal.phone}
            </p>
            <p className={styles.label}>Links</p>
            <p className={styles.value}>
              <a href={personal.links.github} target="_blank" rel="noreferrer">GitHub</a>
              {' · '}
              <a href={personal.links.linkedin} target="_blank" rel="noreferrer">LinkedIn</a>
              {' · '}
              <a href={personal.links.leetcode} target="_blank" rel="noreferrer">LeetCode</a>
            </p>
          </div>
          <div>
            <p className={styles.label}>Focus areas</p>
            <div className={styles.pillRow} style={{ marginBottom: '20px' }}>
              {aboutFocus.map(f => <span key={f} className="pill green">{f}</span>)}
            </div>
            <p className={styles.label}>About</p>
            <p className={styles.value}>
              Developer focused on crafting scalable web experiences and intelligent applications that blend functionality with clean design. From AI-powered travel planners to voice assistants and Android systems, I enjoy turning ambitious ideas into polished, real-world products.
            </p>
            <div className={styles.pillRow}>
              {aboutInterests.map(i => <span key={i} className="pill brown">{i}</span>)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
